import {
  Directive,
  ElementRef,
  HostListener,
  HostBinding,
} from '@angular/core';

@Directive({
  selector: '[appClickToggle]',
})
export class ClickToggleDirective {
  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @HostBinding('attr.aria-expanded') expanded = true;

  @HostListener('click')
  public onClick(): void {
    const parent = this.elementRef.nativeElement;
    const child = parent.nextElementSibling;
    if (!(child instanceof HTMLElement)) {
      return;
    }

    this.expanded = !this.expanded;
    this.toggleChild(child);
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  toggleChild(child: HTMLElement): void {
    child.setAttribute('aria-hidden', String(!this.expanded));
    child.classList.toggle('show');
  }
}
